"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SkeletonLoaderCore = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_router_dom_1 = require("react-router-dom");
const ApiStateStatus = {
    SUCCESS: 'SUCCESS',
    ERROR: 'ERROR',
    LOADING: 'LOADING',
    INVALIDATED: 'NONE'
};
const getApiStateStatus = (apiStates) => {
    if (apiStates.some(apiState => apiState.loading))
        return ApiStateStatus.LOADING;
    if (apiStates.every(apiState => apiState.success))
        return ApiStateStatus.SUCCESS;
    if (apiStates.some(apiState => apiState.error))
        return ApiStateStatus.ERROR;
    return ApiStateStatus.INVALIDATED;
};
function SkeletonLoaderCore({ data, render, renderLoading, renderError }) {
    const status = getApiStateStatus(data);
    return (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [status === ApiStateStatus.SUCCESS && render?.(data.map(state => state.data)), status === ApiStateStatus.ERROR && (renderError ? renderError() : ((0, jsx_runtime_1.jsxs)("div", { className: 'text-center pt-5', children: [(0, jsx_runtime_1.jsx)("h3", { className: "fw-bold", children: "Litujeme, vyskytla se chyba." }), (0, jsx_runtime_1.jsx)("div", { children: "Je mo\u017En\u00E9, \u017Ee aktivn\u00ED obec nem\u00E1 k t\u00E9to str\u00E1nce p\u0159\u00EDstup." }), (0, jsx_runtime_1.jsx)(react_router_dom_1.Link, { to: "/", className: "btn btn-primary fw-bold mt-4", children: "P\u0159ej\u00EDt zp\u011Bt na hlavn\u00ED str\u00E1nku" })] }))), status === ApiStateStatus.LOADING && (renderLoading?.() ?? (0, jsx_runtime_1.jsx)("div", { className: 'text-center', children: "..." })), status === ApiStateStatus.INVALIDATED && (0, jsx_runtime_1.jsx)("div", {})] });
}
exports.SkeletonLoaderCore = SkeletonLoaderCore;
